import styles from "./styles";
import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import CommonStyles from "../../../../../Diathrive/src/utils/CommonStyles";

const CustomInput = ({
  onChange,
  placeholder,
  value,
  isSecure,
  id,
  onClick,
}) => (
  <input
    onChange={onChange}
    placeholder={placeholder}
    value={value}
    isSecure={isSecure}
    id={id}
    onClick={onClick}
    style={styles.dateInput}
  />
);

const CustomDatePicker = (props) => {
  function getYear(date) {
    return parseInt(moment(date).format("YYYY"));
  }

  function getMonth(date) {
    return parseInt(moment(date).format("MM"));
  }

  function* range(start, end, step = 1) {
    if (end === undefined) [end, start] = [start, 0];
    for (let n = start; n < end; n += step) yield n;
  }

  const years = Array.from(range(1900, getYear(new Date()) + 1));
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <DatePicker
      dateFormat="MM/dd/yyyy"
      maxDate={new Date()}
      placeholderText="Select..."
      customInput={<CustomInput />}
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div style={styles.headerContainer}>
          <button
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            style={CommonStyles.mr_8}
          >
            {"<"}
          </button>
          <select
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
            style={CommonStyles.mr_8}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date) - 1]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
            style={CommonStyles.mr_8}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
      {...props}
    />
  );
};

export default CustomDatePicker;
